const CommonRegex = {
    REGEX_EMAIL:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    REGEX_NUMBER: /\d/,
    REGEX_LOWER_CASE: /[a-z]/,
    REGEX_UPPER_CASE: /[A-Z]/,
    REGEX_CHINESE: /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/,
    REGEX_DOMAIN: /^(?=^.{3,255}$)(\.?)([a-zA-Z0-9][-a-zA-Z0-9]{0,62}|\*)(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
    // REGEX_DOMAIN: /^(?=^.{3,255}$)((\*|\*\.)?)[a-zA-Z0-9\u4E00-\u9FA5][-a-zA-Z0-9\u4E00-\u9FA5]{0,62}(\.[a-zA-Z0-9\u4E00-\u9FA5][-a-zA-Z0-9\u4E00-\u9FA5]{0,62})+$/,
    REGEX_ALPHABET: /[a-zA-Z]/g,
};

export default CommonRegex;
